// extracted by mini-css-extract-plugin
module.exports = {"link":"_1410bfd27b--link--a8pCw","content":"_1410bfd27b--content--WhqP3"};